export const translationOrganizations_da_part1 = {
  // Shared actions and labels
  add: "Tilføj",
  attach: "Tilknyt",
  attaching: "Tilknytter...",
  cancel: "Annuller",
  chatbotPlural: "chatbots",
  chatbotSingular: "chatbot",
  creating: "Opretter...",
  currentlyUnassigned: "Ikke tilknyttet i øjeblikket",
  delete: "Slet",
  deleting: "Sletter...",
  detach: "Fjern tilknytning",
  detaching: "Fjerner tilknytning...",
  edit: "Rediger",
  noDomainsConfigured: "Ingen domæner konfigureret",
  remove: "Fjern",
  resend: "Send igen",
  save: "Gem",
  saving: "Gemmer...",
  searchChatbotsPlaceholder: "Søg chatbots…",
  searchOrganizationsPlaceholder: "Søg organisationer…",
  selectChatbotPlaceholder: "Vælg chatbot",
  selectOrganizationPlaceholder: "Vælg organisation",
  unableToAttachChatbot: "Kunne ikke tilknytte chatbot.",
  unableToDetachChatbot: "Kunne ikke fjerne tilknytningen.",
  unassigned: "Ikke tilknyttet",
  // Organizations list page (index.tsx)
  // Organizations list page (index.tsx)
  orgsHeaderTitleAdmin: "Administrer organisationer og chatbots",
  orgsHeaderTitleOwner: "Administrer organisationsadgang",
  orgsHeaderDescriptionAdmin:
    "Admins kan oprette organisationer, oprette eller klone chatbot-ID'er og styre chatbot-tilknytninger på tværs af alle organisationer. Ejere kan administrere medlemmer og invitationer for de organisationer, de ejer.",
  orgsHeaderDescriptionOwner:
    "Administrer medlemmer og invitationer for de organisationer, du ejer.",
  orgsUnableToLoadOrganizations: "Kunne ikke indlæse organisationer.",
  orgsOrganizationCreated: "Organisationen blev oprettet.",
  orgsOrganizationDeleted: 'Organisationen "{name}" blev slettet.',
  orgsUnableToCreateOrganization: "Kunne ikke oprette organisationen.",
  orgsEyebrow: "Organisationer",
  orgsTabOrganizations: "Organisationer",
  orgsTabChatbots: "Chatbots",
  orgsSearchPlaceholder: "Søg efter organisationer, domæner eller tilknyttede chatbot-ID'er",
  orgsCreateOrganization: "Opret organisation",
  orgsCreateDialogTitle: "Opret organisation",
  orgsCreateDialogDescription:
    "Nye organisationer starter uden medlemmer eller chatbots. Du kan invitere ejere og tilknytte chatbots bagefter.",
  orgsOrganizationNameLabel: "Organisationsnavn",
  orgsOrganizationNamePlaceholder: "Acme Support",
  orgsDomainsLabel: "Domæner",
  orgsDomainsPlaceholder: "acme.com, help.acme.com",
  orgsInviteRedirectUrlLabel: "Omdirigerings-URL for invitationer",
  orgsInviteRedirectUrlHelp:
    "Brugere, der accepterer invitationer eller færdiggør registrering, sendes hertil. Brug en godkendt HTTPS-dashboard-URL.",
  orgsInviteRedirectUrlPlaceholder: "https://dashboard.askdiverge.ai",
  orgsCreate: "Opret",
  orgsShowingCount: "Viser {shown} af {total} organisationer",
  orgsForSearch: 'for "{search}"',
  orgsLoadingOrganizationsAria: "Indlæser organisationer",
  orgsLoadingOrganizations: "Indlæser organisationer...",
  orgsEmptyNoMatches: "Ingen organisationer matchede din søgning.",
  orgsEmptyAdmin:
    "Ingen organisationer fundet endnu. Opret den første organisation for at komme i gang.",
  orgsEmptyOwner: "Ingen organisationer at administrere.",
  orgsAdminAccess: "Admin-adgang",
  orgsOwnerAccess: "Ejer-adgang",
  orgsMemberSingular: "Medlem",
  orgsMemberPlural: "Medlemmer",
  orgsOwnerSingular: "Ejer",
  orgsOwnerPlural: "Ejere",
  orgsInviteSingular: "Invitation",
  orgsInvitePlural: "Invitationer",
  orgsAllOrganizationsLoaded: "Alle organisationer er indlæst.",
  orgsLoadingMoreOrganizations: "Indlæser flere organisationer",
  // Chatbot management panel (ChatbotManagementPanel.tsx)
  // Chatbot management panel (ChatbotManagementPanel.tsx)
  botMgmtUnableToLoadChatbots: "Kunne ikke indlæse chatbots.",
  botMgmtChatbotCloned: "Chatbot klonet. Den er ikke tilknyttet i øjeblikket.",
  botMgmtChatbotCreated: "Chatbot oprettet. Den er ikke tilknyttet i øjeblikket.",
  botMgmtUnableToCreateChatbot: "Kunne ikke oprette chatbot.",
  botMgmtSelectOrgBeforeAttach: "Vælg en organisation, før du tilknytter en chatbot.",
  botMgmtAttachedTo: "{chatbotId} blev tilknyttet {organizationName}.",
  botMgmtDetached: "Tilknytningen for {chatbotId} blev fjernet.",
  botMgmtDetachChatbotTitle: "Fjern tilknytningen for {chatbotId}?",
  botMgmtDetachChatbotWarning:
    "Organisationens medlemmer mister adgangen til chatbotten. Dens indstillinger, AI-samtaler og kontaktformularer bevares; dens livechat-historik og -opsætning, Chatbot API-formularer, webhook-hændelser, agenttestsuiter og -arbejdsområder samt butikstilknytning slettes.",
  botMgmtDetachChatbotConfirm: "Fjern tilknytning",
  botMgmtDeleteChatbotTitle: "Slet chatbot {chatbotId}?",
  botMgmtDeleteChatbotWarning:
    "Dette sletter chatbotten permanent, inklusiv indstillinger, samtaler og legitimationsoplysninger. Handlingen kan ikke fortrydes.",
  botMgmtDeleteChatbotConfirm: "Slet chatbot",
  botMgmtChatbotDeleted: "{chatbotId} blev slettet.",
  botMgmtUnableToDeleteChatbot: "Kunne ikke slette chatbotten.",
  botMgmtEyebrow: "Chatbots",
  botMgmtHeading: "Opret, klon og tildel chatbot-ID'er",
  botMgmtIntro:
    "Opret tomme chatbots, eller klon en eksisterende chatbot-konfiguration. Hver chatbot kan kun være tilknyttet én organisation ad gangen.",
  botMgmtStatTotal: "i alt",
  botMgmtStatUnassigned: "ikke tilknyttet",
  botMgmtNewChatbotId: "Nyt chatbot-ID",
  botMgmtChatbotIdPlaceholder: "support-bot-eu",
  botMgmtCreationMode: "Oprettelsestilstand",
  botMgmtSelectMode: "Vælg tilstand",
  botMgmtModeBlank: "Tom",
  botMgmtModeClone: "Klon eksisterende",
  botMgmtSourceChatbot: "Kilde-chatbot",
  botMgmtCreateHelper:
    "Nye chatbot-ID'er oprettes uden tilknytning. Tilknyt dem til en organisation nedenfor efter behov.",
  botMgmtCreateChatbot: "Opret chatbot",
  botMgmtCatalogTitle: "Katalog",
  botMgmtCatalogDescription:
    "Chatbots uden tilknytning kan tilknyttes en organisation. Tilknyttede chatbots skal først have fjernet deres tilknytning, før de kan flyttes.",
  botMgmtLoadingChatbotsAria: "Indlæser chatbots",
  botMgmtLoadingChatbots: "Indlæser chatbots...",
  botMgmtNoChatbotsFound: "Der er ingen chatbots endnu.",
  botMgmtAssignedTo: "Tilknyttet {organization}",
  // Organization detail page (OrganizationDetail.tsx)
  // Organization detail page (OrganizationDetail.tsx)
  orgDetailTabMembers: "Medlemmer",
  orgDetailTabInvitations: "Invitationer",
  orgDetailTabSettings: "Indstillinger",
  orgDetailTabChatbots: "Chatbots",
  orgDetailTabBrands: "Brands",
  orgDetailTabBusiness: "Forretning",
  orgDetailBackToOrganizations: "Tilbage til organisationer",
  orgDetailLoadingOrganization: "Indlæser organisation...",
  orgDetailAdminView: "Admin-visning",
  orgDetailOwnerView: "Ejer-visning",
};
